import { sourceDisplayOutlet } from "@/lib/sourceLabels";

export const renderWithRedactions = (text, sources = []) => {
        if (!text) return null;
        
        const nodes = [];
        const pattern = /\[(?:(\d+)|REDACT:\s*(.*?))\]/g;
        let cursor = 0;
        let match;
        while ((match = pattern.exec(text)) !== null) {
                if (match.index > cursor) {
                        nodes.push(
                                <span key={`text-${cursor}`}>
                                        {text.slice(cursor, match.index)}
                                </span>
                        );
                }
                if (match[1]) {
                        // Citation
                        const n = parseInt(match[1], 10);
                        const src = sources[n - 1];
                        if (!src) {
                                nodes.push(
                                        <sup
                                                key={`citation-${match.index}`}
                                                className="text-[var(--ink-faint)] font-mono"
                                        >
                                                [{n}]
                                        </sup>
                                );
                        } else {
                                nodes.push(
                                        <a
                                                key={`citation-${match.index}`}
                                                href={`#src-${n}`}
                                                title={`${sourceDisplayOutlet(src)} — ${src.title}`}
                                                className="text-[var(--controversy)] hover:text-[var(--ink)] font-mono mx-[1px]"
                                                aria-label={`Ver fonte ${n}: ${src.title}`}
                                        >
                                                <sup>[{n}]</sup>
                                        </a>
                                );
                        }
                } else if (match[2]) {
                        // Redaction
                        nodes.push(
                                <span
                                        key={`redact-${match.index}`}
                                        className="redacted"
                                >
                                        {match[2]}
                                </span>
                        );
                }
                cursor = pattern.lastIndex;
        }
        if (cursor < text.length) {
                nodes.push(<span key={`text-${cursor}`}>{text.slice(cursor)}</span>);
        }
        return nodes.length === 1 && typeof nodes[0] === 'string' ? text : nodes;
};
